import axios from 'axios';
import { BASE_URL } from '../constants';
import { refreshAccessToken } from './refreshAccessToken';

const axiosInstance = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
});

axiosInstance.interceptors.request.use(
    (config) => {
        const userDetails = JSON.parse(localStorage.getItem('userDetails'));
        const token = userDetails?.accessToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        // Set Content-Type to multipart/form-data if data is FormData
        if (config.data instanceof FormData) {
            config.headers['Content-Type'] = 'multipart/form-data';
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            const newToken = await refreshAccessToken();
            axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
            return axiosInstance(originalRequest);
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;